import React, { useState, useEffect } from "react";
import AssessmentValueRow from "./assessmentValueRow";
import AssessmentHelpRow from "./assessmentHelpRow";

const AssessmentActivity = ({ activityObj, imageBase }) => {

    const [studentActivityId, setStudentActivityId] = useState(0);
    const [activityId, setActivityId] = useState(0);
    const [activity, setActivity] = useState("");
    const [activityImgPortrait, setActivityImgPortrait] = useState(window.appURL + "/no-image.png");
    const [activityImgLandscape, setActivityImgLandscape] = useState(window.appURL + "/no-image.png");
    const [studentLiked, setStudentLiked] = useState(30);
    const [studentEase, setStudentEase] = useState(30);
    const [peerLiked, setPeerLiked] = useState(30);
    const [peerEase, setPeerEase] = useState(30);
    const [studentNeeded, setStudentNeeded] = useState([]);
    const [peerNeeded, setPeerNeeded] = useState([]);
    const [parentRemarks, setParentRemarks] = useState("");
    const [peerId, setPeerId] = useState(0);
    const [peer, setPeer] = useState("");


    useEffect(() => {
        // console.log("AssessmentActivity called, activityObj", JSON.stringify(activityObj, null, 2));
        setActivity(activityObj.activity);
        setActivityId(activityObj.activityId);
        setStudentActivityId(activityObj.studentActivityId);
        let imgPortrait = activityObj.imgPortrait;
        let imgLandscape = activityObj.imgLandscape;
        setActivityImgPortrait(imageBase + imgPortrait);
        setActivityImgLandscape(imageBase + imgLandscape);
        setStudentLiked(activityObj.selfLikeDoing);
        setStudentEase(activityObj.selfEasyWork);
        setPeerLiked(activityObj.peerLikeDoing);
        setPeerEase(activityObj.peerEasyWork);
        setStudentNeeded(activityObj.lstSelfNeeded);
        setPeerNeeded(activityObj.lstPeerNeeded);
        setPeerId(activityObj.peerId);
        setPeer(activityObj.peer);
        // setParentRemarks(activityObj.parentRemarks);
    }, [imageBase, activityObj]);

    const saveActivityAssessment = () => {
        // console.log("saveActivityAssessment called");
    };

    const onErrorPortrait = () => {
        setActivityImgPortrait(window.appURL + "/no-image.png");
    };

    const onErrorLandscape = () => {
        setActivityImgLandscape(window.appURL + "/no-image.png");
    };

    return (
        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                <div
                    className="col-md-6 col-sm-6 col-xs-12 "
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        padding: "5px",
                        height: "100%",
                        marginTop: "20px",
                        gap: "5px"
                    }}
                >
                    {/* Portrait Image Container */}
                    <div
                        className="col-md-4 col-sm-4 col-xs-4 "
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "160px",
                            border: "1px solid #ddd",
                            padding:0,
                        }}
                    >
                        <img
                            src={activityImgPortrait}
                            alt="Portrait"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block"
                            }}
                            onError={onErrorPortrait}
                        />
                    </div>

                    {/* Landscape Image Container */}
                    <div
                        className="col-md-8 col-sm-8 col-xs-8 padding-remove"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "160px",
                            border: "1px solid #ddd",
                            padding:0,
                        }}
                    >
                        <img
                            src={activityImgLandscape}
                            alt="Landscape"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block"
                            }}
                            onError={onErrorLandscape}
                        />
                    </div>
                </div>
            </div>

            <div className="col-md-12 col-sm-12 col-xs-12 " >
                <label className="text-left col-md-12 col-sm-12 col-xs-12 padding-remove">
                    {activityObj.activityDesc}
                </label>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                    <AssessmentValueRow
                        qus={"I like doing this work"}
                        value={studentLiked}
                        setValue={setStudentLiked}
                    />
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                    <AssessmentValueRow
                        qus={"I find this work easy"}
                        value={studentEase}
                        setValue={setStudentEase}
                    />
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 " >
                <label className="text-left col-md-12 col-sm-12 col-xs-12 padding-remove">
                    To do this work I needed
                </label>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                    <AssessmentHelpRow
                        selected={studentNeeded}
                        setSelected={setStudentNeeded}
                    />
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 " style={{padding:"2px"}}>
            <label className="peer-label">
                    My peer {peer}
                </label>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                    <AssessmentValueRow
                        qus={"My friend like doing this work"}
                        value={peerLiked}
                        setValue={setPeerLiked}
                    />
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                    <AssessmentValueRow
                        qus={"My friend find this work easy"}
                        value={peerEase}
                        setValue={setPeerEase}
                    />
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 " >
                <label className="text-left col-md-12 col-sm-12 col-xs-12 padding-remove">
                    To do this work my friend needed
                </label>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                    <AssessmentHelpRow
                        selected={peerNeeded}
                        setSelected={setPeerNeeded}
                    />
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 " >
                <label className="text-left col-md-12 col-sm-12 col-xs-12 padding-remove">
                    Parents remarks about childs performance
                </label>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                <div className="form-group col-md-12 col-sm-12 col-xs-12 ">
                    <textarea
                        rows="3"
                        // cols="50"
                        className="col-xs-3 form-control"
                        style={{ margin: "0 0 25px 0", padding: 0, width: "100%", backgroundColor: "#F2F3F4" }}
                        placeholder={"Parents feedback"}
                        value={parentRemarks}
                        onChange={(e) => setParentRemarks(e.target.value)}
                    ></textarea>
                </div>
            </div>
            {/* Save Button */}
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" style={{ margin: "20px 0" }}>
                <div className="col-md-6 col-sm-6 col-xs-12 pull-right padding-remove">
                    <div className="form-group col-md-9 col-sm-9 col-sm-10">
                        <button className="pull-right btn btn-info" onClick={saveActivityAssessment} title="Save">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssessmentActivity;
